import { reduxTurnChartTypes } from 'src/types';
import { TURNCHART_SET, TURNCHART_ADDED, TURNCHART_EDITED, TURNCHART_DELETED } from '../redux-types';

export const turnChartDefaultState: reduxTurnChartTypes.StateType = {
  turnChartList: [],
};

export const turnChartReducer = (
  state = turnChartDefaultState,
  action: reduxTurnChartTypes.ActionType,
): reduxTurnChartTypes.StateType => {
  switch (action.type) {
    case TURNCHART_SET:
      return {
        ...state,
        turnChartList: action.payload,
      };
    case TURNCHART_ADDED:
      const exists = state.turnChartList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        turnChartList: [action.payload, ...state.turnChartList],
      };
    case TURNCHART_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.turnChartList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        turnChartList: [
          ...state.turnChartList.slice(0, updateIndex),
          action.payload,
          ...state.turnChartList.slice(updateIndex + 1),
        ],
      };
    case TURNCHART_DELETED:
      return {
        ...state,
        turnChartList: state.turnChartList.filter((o) => o.id !== action.payload),
      };

    default:
      return state;
  }
};
